import { client } from '../moovyAxiosClient'
import { ConfigDTO } from './dto'

const getConfig = async (guid?: string) => {
  if (!guid) {
    throw new Error('API configuration usergroup guid is missing')
  }

  const response = await client.get<ConfigDTO>('config/' + guid)
  return response.data
}

const ConfigAPI = {
  getConfig
}

export default ConfigAPI
